<script setup lang="ts">
import { X } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import { Input } from '@/components/ui/input'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'
import { usePCSSearchInput } from '@/services/usePCSSearchInput'

const { t } = useI18n()

const { inputValue, isInputNotEmpty, navigateToSearch, clearInputValue } =
	usePCSSearchInput()
</script>

<template>
	<div class="relative flex w-full items-center">
		<Input
			v-model="inputValue"
			@keyup.enter="navigateToSearch"
			type="text"
			:placeholder="t('pcs_search_placeholder')"
			class="typography-b2-reg rounded-full border-2 border-n-950 py-[10px] pl-[52px] pr-48px text-n-950 mdp:h-60px mdp:pl-24px mdp:pr-[100px]"
		></Input>

		<div
			v-if="isInputNotEmpty"
			@click="clearInputValue"
			class="absolute right-16px top-[14px] cursor-pointer rounded-full mdp:right-[62px] mdp:top-[18px] mdp:bg-transparent mdp:hover:bg-n-100 mdp:active:bg-n-300"
		>
			<BaseIcon name="input-close" class="h-16px w-16px mdp:hidden" />
			<X
				class="hidden h-24px w-24px p-4px text-white mdp:block mdp:text-n-950"
			/>
		</div>

		<!-- tablet search icon -->
		<div
			@click="navigateToSearch"
			class="absolute right-12px hidden h-32px w-32px cursor-pointer items-center justify-center rounded-full bg-o-500 hover:bg-o-600 mdp:flex mdp:h-[44px] mdp:w-[44px]"
		>
			<BaseIcon name="search-v2" class="h-24px w-24px fill-white" />
		</div>
		<!-- mobile search icon -->
		<div
			@click="navigateToSearch"
			class="absolute left-16px flex cursor-pointer items-center justify-center rounded-full mdp:hidden"
		>
			<BaseIcon name="search-v2" class="h-24px w-24px fill-black" />
		</div>
	</div>
</template>
